import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import AdminAccess from "../Pages/AdminAccess";
import AdminDashboard from "../Pages/AdminDashboard";

export const Router = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/admin-dashboard" element={<AdminDashboard />} />
        <Route path="/" element={<AdminAccess />} />
      </Routes>
    </BrowserRouter>
  );
};
